import { createSelector } from "reselect";

const shippingInfoSelector = (state) => state.shippingInfo;

export const getReceiver = createSelector(
    [shippingInfoSelector],
    state => state.receiver
)


export const getFurigana = createSelector(
    [shippingInfoSelector],
    state => state.furigana
)


export const getTelephone = createSelector(
    [shippingInfoSelector],
    state => state.telephone
)


export const getPostCode = createSelector(
    [shippingInfoSelector],
    state => state.postCode
)


export const getPrefecture = createSelector(
    [shippingInfoSelector],
    state => state.prefecture
)


export const getCity = createSelector(
    [shippingInfoSelector],
    state => state.city
)


export const getAddress = createSelector(
    [shippingInfoSelector],
    state => state.address
)


export const getApartmentAndRoom = createSelector(
    [shippingInfoSelector],
    state => state.apartmentAndRoom
)